import { useRef } from 'react';
import { Provider } from 'react-redux';
import SubscriptionsActionsHost from '../components/SubscriptionActionsHost';
import { initStore } from '../store/store';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
export function SubscriptionActionsHostWrapper({
  objectId,
  closeSidebar = () => {},
  children
}) {
  if (!objectId) {
    throw new Error('No objectId provided to SubscriptionsActionsHostWrapper');
  }
  const store = useRef(initStore());
  const client = useRef(new DataFetchingClient());
  return /*#__PURE__*/_jsx(Provider, {
    store: store.current,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: client.current,
      children: /*#__PURE__*/_jsx(SubscriptionsActionsHost, {
        objectId: objectId,
        closeSidebar: closeSidebar,
        children: children
      })
    })
  });
}